import { environment } from "src/environments/environment";

export const API_ROUTES = {
  ACCOUNT: {
    login: `${environment.apiBaseUrl}v1/superAdmin/login`,
    forgetPassword: `${environment.apiBaseUrl}v1/superAdmin/forgetPassword`,
    resetPassword: `${environment.apiBaseUrl}v1/superAdmin/resetPassword`,
    verifyEmail: `${environment.apiBaseUrl}v1/superAdmin/emailVerification`,
    viewProfile: `${environment.apiBaseUrl}v1/superAdmin/viewProfile`,
    changePassword: `${environment.apiBaseUrl}v1/superAdmin/changePassword`,
    editProfile: `${environment.apiBaseUrl}v1/superAdmin/editProfile`,
    getWrongLoginAttempts: `${environment.apiBaseUrl}v1/superAdmin/getWrongLoginAttempts`,
    deleteImage: `${environment.apiBaseUrl}v1/videoFolder/deleteImages`,
    uploadImage: `${environment.apiBaseUrl}v1/videoFolder/uploadImages`,
    inviteSuperAdmin: `${environment.apiBaseUrl}v1/superadmin/invite`,
    superAdminUsersListing: `${environment.apiBaseUrl}v1/superadmin/lisiting`
  },
  BLOG: {
    getBlogs: `${environment.apiBaseUrl}v1/blogs/getBlogs`,
    deleteBlog: `${environment.apiBaseUrl}v1/blogs/deleteBlog`,
    getBlogDetails: `${environment.apiBaseUrl}v1/blogs/blog`,
    getBlogsCategory: `${environment.apiBaseUrl}v1/blogs/getBlogsByCategory`,
    addBlog: `${environment.apiBaseUrl}v1/blogs/createBlog`,
    updateBlog: `${environment.apiBaseUrl}v1/blogs/updateBlog`
  },
  DASHBOARD: {
    getDashboardData: `${environment.apiBaseUrl}v1/superAdmin/dashboardData`
  },
  CLIENT: {
    monthlyDataCC: `${environment.apiBaseUrl}v1/superAdmin/monthlyComparison`,
    monthlyDataDistanceApi: `${environment.apiBaseUrl}v1/superAdmin/distanceApiHitsSummary`,
    monthlyDataEmailCount: `${environment.apiBaseUrl}v1/superAdmin/emailCountMonthSummary`,
    monthlyEmailCountPerClient: `${environment.apiBaseUrl}v1/superAdmin/emailCountsPerCompany`,
    multiChartYear: `${environment.apiBaseUrl}v1/superAdmin/companyYearlyEmailCounts`,
    multiChartYearDistance: `${environment.apiBaseUrl}v1/superAdmin/companyYearlyDistanceApiCounts`,
    distanceApiHit: `${environment.apiBaseUrl}v1/superAdmin/distanceApiHitsSummary`,
    distanceApiHitPerCompany: `${environment.apiBaseUrl}v1/superAdmin/disatanceApiCountsPerCompany`,
    getyearlyFiltered: `${environment.apiBaseUrl}v1/client/yearlyFilterData`,
    getClientList: `${environment.apiBaseUrl}v1/client/clients`,
    deleteClient: `${environment.apiBaseUrl}v1/client/delete`,
    blockClient: `${environment.apiBaseUrl}v1/client/block`,
    getClientById: `${environment.apiBaseUrl}v1/client/client`,
    getServiceList: `${environment.apiBaseUrl}v1/services/services`,
    addNewClient: `${environment.apiBaseUrl}v1/client/invite`,
    updateClient: `${environment.apiBaseUrl}v1/client/edit`,
    accessClient: `${environment.apiBaseUrl}v1/client/accessToClient`,
    createSubscription: `${environment.apiBaseUrl}v1/client/createSubscription`,
    cancelSubscription: `${environment.apiBaseUrl}v1/client/cancelSubscription`,
    subscriptionList: `${environment.apiBaseUrl}v1/client/subscriptionList`,
    transactionList: `${environment.apiBaseUrl}v1/superAdmin/subscriptionTransaction`,
    clientTransactionListing: `${environment.apiBaseUrl}v1/client/transactionListing`,
    requestPay: `${environment.apiBaseUrl}v1/client/requestSubscriptionPayment`,
    smsListings: `${environment.apiBaseUrl}v1/superAdmin/availableNumbers`,
    activeNumbers: `${environment.apiBaseUrl}v1/superAdmin/activeNumbers`,
    updatePhoneNumber: `${environment.apiBaseUrl}v1/superAdmin/assignTwilioNumber`,
    reassignNumber: `${environment.apiBaseUrl}v1/superAdmin/reassignTwilioNumber`,
    unassignNumber: `${environment.apiBaseUrl}v1/superAdmin/releaseNumber`,
    smsYearlyChart: `${environment.apiBaseUrl}v1/superAdmin/smsSegmentsCountMonthSummary`,
    monthlySmsCountPerClient: `${environment.apiBaseUrl}v1/superAdmin/smsSegmentsCountsPerCompany`,
    smsMultiYearChart: `${environment.apiBaseUrl}v1/superAdmin/companyYearlySmsSegmetCounts`,
    subsTransactionHistory: `${environment.apiBaseUrl}v1/superAdmin/subscriptionTransactionHistory`,

    aiYearlyChart: `${environment.apiBaseUrl}v1/superAdmin/aiMinuteMonthSummary`,
    monthlyAICountPerClient: `${environment.apiBaseUrl}v1/superAdmin/aiMinuteCountsPerCompany`,
    aiMultiYearChart: `${environment.apiBaseUrl}v1/superAdmin/companyYearlyAiMinuteCounts`
  },
  CUSTOMER: {
    getCustomerList: `${environment.apiBaseUrl}v1/customer/customers`,
    getCustomerById: `${environment.apiBaseUrl}v1/customer/customer`,
  },
  Roles: {
    getPermissions: `${environment.apiBaseUrl}v1/permissions/getPermissionsForClient`,
    setPermissions: `${environment.apiBaseUrl}v1/permissions/setPermissionsForClient`,
    companyPermission: `${environment.apiBaseUrl}v1/client/compnayPermissionForClient`,
    companyExtraPermission: `${environment.apiBaseUrl}v1/client/compnayExtraPermission`
  },
  SERVICE: {
    createService: `${environment.apiBaseUrl}v1/services/createService`,
    updateService: `${environment.apiBaseUrl}v1/services/updateService`,
    deleteService: `${environment.apiBaseUrl}v1/services/deleteService`
  },
  COACHING: {
    createFolder: `${environment.apiBaseUrl}v1/videoFolder/createFolder`,
    deleteFolder: `${environment.apiBaseUrl}v1/videoFolder/deleteFolder`,
    getFolders: `${environment.apiBaseUrl}v1/videoFolder/getFolders`,
    uploadVideo: `${environment.apiBaseUrl}v1/videoFolder/uploadVideos`,
    getVideos: `${environment.apiBaseUrl}v1/videoFolder/getVideos`,
    deleteVideo: `${environment.apiBaseUrl}v1/videoFolder/deleteVideo`,
    createFeed: `${environment.apiBaseUrl}v1/feeds/createFeeds`,
    getFeeds: `${environment.apiBaseUrl}v1/feeds/getFeeds`,
    getVideoDetail: `${environment.apiBaseUrl}v1/videoFolder/getVideoById`,
    deleteComment: `${environment.apiBaseUrl}v1/commentLikes/deleteComment`,
    addLikes: `${environment.apiBaseUrl}v1/commentLikes/addLikes`,
    unLike: `${environment.apiBaseUrl}v1/commentLikes/unLike`,
    addViews: `${environment.apiBaseUrl}v1/commentLikes/AddViews`,
    addComment: `${environment.apiBaseUrl}v1/commentLikes/addComment`,
    deleteFeed: `${environment.apiBaseUrl}v1/feeds/deleteFeed`,
    getFeedById: `${environment.apiBaseUrl}v1/feeds/getFeedById`,
    getCount: `${environment.apiBaseUrl}v1/superAdmin/notificationList`,
    getFeedCount: `${environment.apiBaseUrl}v1/feeds/updateNotification`,
    setOrder: `${environment.apiBaseUrl}v1/videoFolder/arrangeVideos`,
  },
  MEETING: {
    createMeeting: `${environment.apiBaseUrl}v1/meetings/createMeeting`,
    getMeetings: `${environment.apiBaseUrl}v1/meetings/meetingList`,
    getSignature: `${environment.apiBaseUrl}v1/meetings/verifySign`,
    updateStatus: `${environment.apiBaseUrl}v1/meetings/updateMeetingStatus`,
    deleteMeeting: `${environment.apiBaseUrl}v1/meetings/deleteMeeting`,
    updateMeeting: `${environment.apiBaseUrl}v1/meetings/updateMeeting`
  },
  Emails: {
    emailList: `${environment.apiBaseUrl}v1/client/pendingEmails`,
    updateStatus: `${environment.apiBaseUrl}v1/client/updateMarketEmailStatus`,

  },
  DISTANCEAPI: {
    serviceCount: `${environment.apiBaseUrl}v1/superAdmin/airmServiceCount`,

  },
  VALORAPI: {
    updateValorCreds: `${environment.apiBaseUrl}v1/superAdmin/updateValorAccount`,
    getValorCreds: `${environment.apiBaseUrl}v1/superAdmin/valorAccount`,
    takePayment: `${environment.apiBaseUrl}v1/superAdmin/seprateValorCharge`,
    getActiveGateway: `${environment.apiBaseUrl}v1/superAdmin/ActiveGateway`
  },
  PACKAGES: {
    createSubscriptionPackage: `${environment.apiBaseUrl}v1/superAdmin/createSubscriptionPackage`,
    packagesList: `${environment.apiBaseUrl}v1/superAdmin/subscriptionPackage`,
    packageDetail: `${environment.apiBaseUrl}v1/superAdmin/subscriptionPackageDetail`,
    deletePackage: `${environment.apiBaseUrl}v1/superadmin/deleteSubscriptionPackage`,
    proRatedPackage: `${environment.apiBaseUrl}v1/client/getProratedAmount`
  },

  HELPSUPPORT: {
    createSupportTicekt: `${environment.apiBaseUrl}v1/support/createSupportTicket`,
    ticketList: `${environment.apiBaseUrl}v1/support/getSupportTicket`
  },

  UPLOAD: {
    init: `${environment.apiBaseUrl}v1/videoFolder/init`,
    uploadPart: `${environment.apiBaseUrl}v1/videoFolder/uploadPart`,
    complete: `${environment.apiBaseUrl}v1/videoFolder/completeUpload`
  },
  RUNPAY: {
    runPayCreds: `${environment.apiBaseUrl}v1/superAdmin/runPaymentAccount`,
    updateRunPayCreds: `${environment.apiBaseUrl}v1/superAdmin/updateRunPaymentAccount`,
    updateGateway: `${environment.apiBaseUrl}v1/superAdmin/updateGateway`
  }
}
